import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import './css/inicio.css';
import diploma from "./assets/inicio/Certificado entrenamiento.png";
import portada1 from "./assets/inicio/portada_foto1.JPG";
import portada2 from "./assets/inicio/portada_foto2.JPG";
import portada3 from "./assets/inicio/portada_foto3.JPG";
import videoInicio from "./assets/inicio/Oifem 2023.mp4"; 


export default function Inicio() {

    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://formfacade.com/include/103307635053267445224/form/1FAIpQLSenMCJekEXwlacsKiU_wRs65J7k0Q2zkRIqVqQAvSkNeaS25w/classic.js?div=ff-compose";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div id="inicio">
            <div className="destacado">
                <h1>¡Participa en la sexta edición de la OIFem!</h1>
                <div className="video-text">
                    <div id="inicio-video-holder">
                        <video width="100%" height="100%" controls>
                            <source src={videoInicio} type="video/mp4"></source>
                        </video>
                    </div>
                    <div>
                        <p>
                            Recibirás clases de programación competitiva que se ajusten a tu nivel actual y podrás mejorar con otras alumnas con intereses similares a los tuyos. Conocerás también
                            a referentes en el campo de la programación y podrás representar a España a nivel europeo. Ya puedes <Link to="/inscripcion">inscribirte</Link> para participar en la edición del curso 2025/26 y para
                            acceder a materiales de años anteriores.
                        </p>
                        <p>
                            Los dos clasificatorios de la sexta edición tendrán lugar del 23 al 25 de enero y el 7 de febrero respectivamente.
                            La final nacional de la VI OIFem (2026) será en <b>Barcelona</b> del 19 al 22 de marzo.
                        </p>
                        <p>
                            Además, como todas nuestras actividades son gratuitas, estamos siempre buscando <Link to="quienes-somos">colaboradores,</Link> <Link to="colabora">donantes y patrocinadores.</Link> Tenemos planes para empresas, opciones para
                            administraciones públicas y la posibilidad de donar a través de Paypal. ¡Gracias por tu ayuda!
                        </p>   
                    </div>
                </div>
            </div>

            <h1>¿Qué puedes esperar de la OIFem?</h1>
            <div className="que-esperar-oifem">
                <div className="foto">
                    <img src={portada1} alt="Portada 1" />
                </div>
                <div className="text">
                    <p>
                        La Olimpiada Informática Femenina es un concurso de programación algorítmica para alumnas menores de 20 años que cursen educación secundaria en España (ESO,
                        Bachillerato, FP de Grado Medio) o su equivalente en el extranjero (pero en este caso han de tener la nacionalidad española). El concurso consiste en una primera fase
                        de selección online, las clasificadas son invitadas a una fase final presencial, donde se selecciona a las cuatro representantes españolas en la Olimpiada Informática
                        Femenina Europea (EGOI).
                    </p>
                    <p>Es una iniciativa que se organiza anualmente y las inscripciones ya están abiertas para la edición de 2025/26.</p>
                    <p><b>Todas las actividades de la OIFem, incluidas las formaciones, concursos y viajes* para las premiadas son gratuitas,</b> gracias a los patrocinadores y voluntarios.</p>
                    <p className="letra-pequena">
                        *Los viajes se cubren de/a territorio nacional. Si tienes nacionalida española pero resides en el extranjero la logística y costes del trayecto a/desde España corren
                        de tu cargo.
                    </p>
                </div>
            </div>
            <div className="que-esperar-oifem">
                <div className="text">
                    <p>
                        Se invitará a 15 finalistas (las 15 mejores puntuaciones del clasificatorio online) a una final presencial, de donde saldrán una medalla de oro, una de plata y dos
                        bronces.
                    </p>
                    <p>Las medallistas representarán a España en la EGOI de 2025.</p>
                    <p>
                        <b>Ofrecemos clases (en C++) para todos los niveles, desde introducción hasta competitivo avanzado,</b> donde aprenderemos sobre teoría de números, máscaras de bits y
                        árboles de segmentos... Además, tenemos un servidor de Discord por donde nos comunicamos con las concursantes y por donde como concursante puedes comentar problemas y
                        teoría, por lo que es recomendable apuntarse pronto.
                    </p>
                </div>
                <div className="foto">
                    <img src={portada2} alt="Portada 2" />
                </div>
            </div>
            <div className="que-esperar-oifem">
                <div className="foto">
                    <img src={portada3} alt="Portada 3" />
                </div>
                <div className="text">
                    <p>Si quieres unirte solo tienes que inscribirte a la nueva edición y accederás a muchos materiales.</p>
                    <p>Los lenguajes de programación permitidos son los mismos que en la EGOI: C/C++, Python y Java.</p>
                    <p>
                        Durante los concursos <b>está prohibido</b> comunicarse con otras personas (en particular con otras concursantes) ya sea de los problemas o de otros temas relacionados
                        con la programación. Los concursos son individuales.
                    </p>
                    <p>
                        No se pueden usar códigos ni fragmentos de código que no sean de creación propia del concursante, y está especialmente prohibido buscar soluciones por internet.
                    </p>
                </div>
            </div>
            <p>Las concursantes que completen con éxito el programa de entrenamientos de su nivel recibirán un certificado firmado como el siguiente:</p>
            <div className="diploma-holder">
                <img src={diploma} alt="certificado de entrenamiento" />
            </div>
            <h2>¿Quieres que te informemos de nuestros concursos, cursos y actividades?</h2>

            <div id="ff-compose"></div>

            <div className="calendar-holder">
                <iframe src="https://calendar.google.com/calendar/embed?src=olimpiadainformaticafemenina%40gmail.com&ctz=Europe%2FMadrid" className="calendar" title="Google Calendar"></iframe>
            </div>
        </div>
    );
}
